import React, {useLayoutEffect} from 'react';
import SignIn from "@containers/auth/signIn/SignIn";
import {setCookie} from "@helpers/cookie/cookie";

const LoginPage = () => {
    useLayoutEffect(() => {
        setCookie("token", '', {"max-age": -1});
        setCookie("refreshToken", '', {"max-age": -1});
    }, []);

    return (
        <SignIn/>
    );
};

export default LoginPage;